import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Title} from '@angular/platform-browser';
import {NewdelegationService} from "../service/newdelegation.service";
import {asciiValidator} from "common-domain";

@Component({
    selector: 'newdelegation',
    templateUrl: './newdelegation.component.html',
    styleUrls: ['./newdelegation.component.scss'],
    standalone: false
})
export class NewdelegationComponent implements OnInit {

  newDelegationForm: FormGroup;

  emailSent: boolean;

  errorMessages: any;

  constructor(private titleService: Title, private formBuilder: FormBuilder, private newDelegationService: NewdelegationService) {
  }

  ngOnInit() {
    this.createForm();
    this.titleService.setTitle('New Delegation');
  }

  onSubmit() {
    const formValue = this.newDelegationForm.value;
    const newGtld = formValue.newGTLD;
    const delegationToken = formValue.delegationToken;

    this.emailSent = false;
    this.errorMessages = null;

    this.newDelegationService.startProcess(newGtld, delegationToken).subscribe({
      next: (data) => {
        this.emailSent = true;
      },
      error: (error) => {
        this.emailSent = false;
        // Extract first error message from SDK error format
        if (error && error.errorMessages && error.errorMessages.length > 0) {
          this.errorMessages = { message: error.errorMessages[0] };
        } else {
          this.errorMessages = error;
        }
      }
    });
  }


  private createForm() {
    this.newDelegationForm = this.formBuilder.group({
      newGTLD: new FormControl('', [Validators.required, asciiValidator]),
      delegationToken: new FormControl('', [Validators.required])
    });
  }

}
